import { createAction } from '@reduxjs/toolkit';

import ObjectID from 'bson-objectid';

export const addShipment = createAction(
  'addShipment', ({
    id = ObjectID().toString(),
    legId,
    travelerId,
    labelId,
    insuranceId,
    packagingId,
    productLineId,
    parentId,
    additionalInfo,
    productLineName,
    state = 'partial',
  }) => ({
    payload: {
      id,
      state,
      additionalInfo,
      legId,
      travelerId,
      labelId,
      insuranceId,
      packagingId,
      productLineId,
      productLineName,
      parentId,
    },
  }),
);
